<template>
  <div class="debt-providers-filter">
    <b-row class="debt-providers-filter__row">
      <b-col
        md="2"
        class="debt-providers-filter__col"
      >
        <b-input-group class="debt-providers-filter__input-group">
          <date-picker
            placeholder="Từ"
            class="debt-providers-filter__date-picker form-control form-control-sm"
            :config="datePickerConfig"
            v-model="localFilters.fromDate"
            @input="onFilterChange"
          />
        </b-input-group>
      </b-col>
      <b-col
        md="2"
        class="debt-providers-filter__col"
      >
        <b-input-group class="debt-providers-filter__input-group">
          <date-picker
            placeholder="Đến"
            class="debt-providers-filter__date-picker form-control form-control-sm"
            :config="datePickerConfig"
            v-model="localFilters.toDate"
            @input="onFilterChange"
          />
        </b-input-group>
      </b-col>
      <b-col
        md="3"
        class="debt-providers-filter__col"
      >
        <SupplierAutosuggest
          v-model="localFilters.providerId"
          :initial-label="localFilters.searchProvider"
          allow-all
          placeholder="nhà cung cấp"
          class="debt-providers-filter__autosuggest"
          @input="onFilterChange"
          @selected="onProviderSelected"
        />
      </b-col>
      <b-col
        md="1"
        class="debt-providers-filter__col"
      >
        <b-button
          class="debt-providers-filter__button"
          variant="primary"
          size="sm"
          @click="onApplyFilters"
          :disabled="isLoading"
        >
          <b-spinner small v-if="isLoading"></b-spinner>
          <span v-else>Lọc</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SupplierAutosuggest from '@/view/components/suppliers/SupplierAutosuggest.vue';

export default {
  name: 'DebtProvidersFilter',
  components: {
    SupplierAutosuggest,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        fromDate: null,
        toDate: null,
        searchProvider: '',
        providerId: null,
      }),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localFilters: { ...this.value },
      datePickerConfig: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: true,
        showClose: true,
        minDate: false,
        maxDate: false,
        locale: 'vi',
        sideBySide: true,
      },
    };
  },
  watch: {
    value: {
      handler(newValue) {
        this.localFilters = { ...newValue };
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Handle filter value changes
     */
    onFilterChange() {
      this.$emit('input', { ...this.localFilters });
    },

    // SupplierAutosuggest emits @selected với full item khi chọn, null khi xóa
    onProviderSelected(item) {
      this.localFilters.searchProvider = item ? item.fullName : '';
      this.onFilterChange();
    },

    /**
     * Handle apply filters button click
     */
    onApplyFilters() {
      this.$emit('apply-filters', { ...this.localFilters });
    },

    /**
     * Reset all filters to default values
     */
    resetFilters() {
      this.localFilters = {
        fromDate: null,
        toDate: null,
        searchProvider: '',
        providerId: null,
      };
      this.onFilterChange();
    },
  },
};
</script>

<style lang="scss" scoped>
.debt-providers-filter {
  &__row {
    margin-bottom: 1.25rem;
  }

  &__col {
    display: flex;
    align-items: center;
  }

  &__input-group {
    width: 100%;
  }

  &__date-picker {
    font-size: 0.875rem;
    border-radius: 0.25rem;

    &:focus {
      border-color: #80bdff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
  }

  &__autosuggest {
    width: 100%;

    :deep(.form-control) {
      font-size: 0.875rem;
    }
  }

  &__button {
    font-weight: 600;
    width: 70px;
    white-space: nowrap;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  // Responsive design
  @media (max-width: 768px) {
    &__col {
      margin-bottom: 0.75rem;
    }

    &__button {
      width: 100%;
    }
  }
}
</style>
